import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentMixin from '@/_mixins/attachment'
import { FileTypes } from '@/types/file-types'

@Component({
    mixins: [AttachmentMixin],
})
export default class Attachment extends Mixins<MixinInterface>(AttachmentMixin) {
    @Prop({ required: true }) url!: string
    @Prop({ required: true }) name!: string
    @Prop({ required: true }) height!: string
    @Prop() contain!: boolean
    @Prop({ default: false }) tile!: boolean
    @Prop({ default: false }) useAnonymousToken!: boolean
    @Prop({ default: false }) fileId!: string

    FileTypes = FileTypes
    error = false

    get fileType() {
        return this.name ? this.name.split('.').slice(-1)[0] : null
    }

    @Watch('url')
    @Watch('anonymousImgUrl')
    setError() {
        this.error = false
    }

    handleError() {
        this.error = true
    }

    anonymousImgUrl = null as null | string
    @Watch('fileId', { immediate: true })
    async getImage() {
        if (!this.fileId || !this.useAnonymousToken) return

        const baseFile = await this.downloadAttachmentAsFileObject(
            this.fileId,
            this.useAnonymousToken
        )
        const blobUrl = URL.createObjectURL(baseFile.data)
        this.anonymousImgUrl = blobUrl
    }
}
